import { CardContent } from '@src/components/Editor/types'
import { Check, CheckMetadata, CheckType, CheckWithMetadata } from '@src/types/checks'
import { createAsyncAction, createStandardAction } from 'typesafe-actions'
import { CheckCategory } from '../document/types'

export const RUN_CHECKS = 'check/RUN_CHECKS'

export const CHECK_COUNT = 'check/CHECK_COUNT'
export const CHECK_START = 'check/CHECK_START'
export const SET_EXPECTED_CHECKS = 'check/SET_EXPECTED_CHECKS'
export const CHECK_START_FAIL = 'check/CHECK_START_FAIL'
export const CHECK_STATUS = 'check/CHECK_STATUS'
export const CHECK_STATUS_FAIL = 'check/CHECK_STATUS_FAIL'

export const GET_CHECK = 'check/GET_CHECK'
export const GET_CHECK_SUCCESS = 'check/GET_CHECK_SUCCESS'

export const SET_CHECK = 'check/SET_CHECK'
export const GET_CHECK_FAIL = 'check/GET_CHECK_FAIL'
export const CLEAR_CHECKS = 'check/CLEAR_CHECKS'

// Card Actions
export const CARD_STATE_UPDATE = 'check/CARD_STATE_UPDATE'
export const CARD_STATE_UPDATE_SUCCESS = 'check/CARD_STATE_UPDATE_SUCCESS'
export const CARD_STATE_UPDATE_FAIL = 'check/CARD_STATE_UPDATE_FAIL'
export const CARD_STATE_ACCEPT = 'check/CARD_STATE_ACCEPT'
export const CARD_STATE_REJECT = 'check/CARD_STATE_REJECT'
export const CARD_STATE_READ = 'check/CARD_STATE_READ'

export const CARD_STATE_BULK_UPDATE = 'checks/CARD_STATE_BULK_UPDATE'
export const CARD_STATE_BULK_UPDATE_SUCCESS = 'checks/CARD_STATE_BULK_UPDATE_SUCCESS'
export const CARD_STATE_BULK_UPDATE_FAIL = 'checks/CARD_STATE_BULK_UPDATE_FAIL'

// WTAI actions
export const WTAI_RUN_ANALYZE = 'check/WTAI_RUN_ANALYZE'
export const POLLING_PLAGIARISM_START = 'check/POLLING_PLAGIARISM_START'

export const PLAGSCAN = 'plagscan'
export const TII = 'turnitin'

export const PUSHER_RUN_PLAGIARISM = 'check/PUSHER_RUN_PLAGIARISM'

export const ALL_CHECKS_COMPLETE = 'check/ALL_CHECKS_COMPLETE'
export const CHECKS_RUNNING = 'check/CHECKS_RUNNING'
export const PARTIAL_PLAGIARISM_CHECK_START = 'check/PARTIAL_PLAGIARISM_CHECK_START'
export const PARTIAL_PLAGIARISM_CHECK_END = 'check/PARTIAL_PLAGIARISM_CHECK_END'
export const CHECKS_CANCELLED = 'check/CHECKS_CANCELLED'

export interface CheckPayloadBase {
  type: CheckType
  isRecheck?: boolean
  provider?: typeof PLAGSCAN | typeof TII
}

export interface CheckStartFail {
  plagiarism?: boolean
  grammar?: boolean
  error: Error
}

export interface RunChecksPayload {
  isRecheck?: boolean
  checkCategory: CheckCategory
}

export type CardActionsState = 'read' | 'accepted' | 'rejected' | 'hidden' | 'gated'

export interface CardActionsPayload extends CheckPayloadBase {
  card: CardContent
  newState: CardActionsState
  selectedReplacement?: string
  rule: string
}

export interface CardActionsMeta {
  ctaText?: string
}

export interface CardActionsError extends Error {
  metadataId: string
}

export interface CheckMeta {
  origin?: string
}

export interface WtaiCheckPayload {
  messageId: string
}

export interface ChecksToExpectPayload {
  checks: CheckType[]
}

export interface PartialPlagiarismCheckEndPayload {
  plagiarismFound: boolean
}

export const runChecks = createStandardAction(RUN_CHECKS)<RunChecksPayload, CheckMeta>()

export const checkStart = createStandardAction(CHECK_START)<CheckPayloadBase, CheckMeta>()
export const checkStartFail = createStandardAction(CHECK_START_FAIL)<CheckStartFail>()

export const setExpectedChecks = createStandardAction(SET_EXPECTED_CHECKS)<
  ChecksToExpectPayload,
  CheckMeta
>()

export const checkCount = createStandardAction(CHECK_COUNT)<CheckPayloadBase, CheckMeta>()

export const pollingPlagiarismStart = createStandardAction(POLLING_PLAGIARISM_START)<
  CheckStatusPayload
>()

export const partialPlagiarismCheckStart = createStandardAction(
  PARTIAL_PLAGIARISM_CHECK_START
)()

export const partialPlagiarismCheckEnd = createStandardAction(
  PARTIAL_PLAGIARISM_CHECK_END
)<PartialPlagiarismCheckEndPayload>()

export interface CheckStatusPayload extends CheckPayloadBase {
  messageId: string
  status?: string
}

export interface CheckStatusFail {
  error: Error
}

export const setCheck = createStandardAction(SET_CHECK)<Check>()
export const clearChecks = createStandardAction(CLEAR_CHECKS)()

export const checkStatus = createStandardAction(CHECK_STATUS)<CheckStatusPayload>()
export const checkStatusFail = createStandardAction(CHECK_STATUS_FAIL)<CheckStatusFail>()

export interface CheckResultsError extends Error {
  type: CheckType
  status: string
  finished?: boolean
}

export const checkResults = createAsyncAction(
  GET_CHECK,
  GET_CHECK_SUCCESS,
  GET_CHECK_FAIL
)<CheckPayloadBase, CheckWithMetadata, CheckResultsError>()

export const acceptCard = createStandardAction(CARD_STATE_ACCEPT)<CardActionsPayload>()
export const rejectCard = createStandardAction(CARD_STATE_REJECT)<CardActionsPayload>()
export const readCard = createStandardAction(CARD_STATE_READ)<CardActionsPayload>()

export const updateCardState = createStandardAction(CARD_STATE_UPDATE)<
  CardActionsPayload,
  CardActionsMeta
>()

export const updateCardSuccess = createStandardAction(CARD_STATE_UPDATE_SUCCESS)<
  CheckMetadata
>()

export const updateCardFail = createStandardAction(CARD_STATE_UPDATE_FAIL)<
  CardActionsError
>()

export interface BulkMetadataPayload {
  ids: string[]
  state: CardActionsState
}

export const updateBulkMetadata = createAsyncAction(
  CARD_STATE_BULK_UPDATE,
  CARD_STATE_BULK_UPDATE_SUCCESS,
  CARD_STATE_BULK_UPDATE_FAIL
)<BulkMetadataPayload, {}, Error>()

export const pusherRunPlagiarismCheck = createStandardAction(PUSHER_RUN_PLAGIARISM)<
  RunChecksPayload,
  CheckMeta
>()

export const checksComplete = createStandardAction(ALL_CHECKS_COMPLETE)()
export const checksCancelled = createStandardAction(CHECKS_CANCELLED)()



// WEBPACK FOOTER //
// ./src/state/checks/actions.ts